import { dictEnumListAll,getCOMType } from "@/api/COldForNew";
//字典缓存
export default {
  data() {
    return {
      BusinessOldMachineStatusEnum: [], //旧机状态
      BusinessRecycleStatusEnum: [], //回收状态 订单状态
      BusinessSettleStatusEnum: [], //结算状态
      OldMachineSubsidyOnlineStatusEnum:[],
      JdExceptionTypeEnum:[],
      OldMachineRecoveryStatus:[],//旧机订单状态
      PayTypeEnum:[],
      COMType:[],//旧机品类
      InvoiceSignStatusEnum: [],//签约状态
    };
  },
  created() {
    this.getDictEnumList();
    this.getCOM()
  },
  methods: {
    async getDictEnumList() {
      let res = await dictEnumListAll();

      if (res.statusCode === 200) {

        this.BusinessOldMachineStatusEnum = [];
        this.BusinessRecycleStatusEnum = [];
        this.BusinessSettleStatusEnum = [];
        this.OldMachineSubsidyOnlineStatusEnum= [];
        this.JdExceptionTypeEnum = [];
        this.OldMachineRecoveryStatus = []
        this.PayTypeEnum = [];
        this.InvoiceSignStatusEnum = [];

        res.data.forEach(item => {
          switch (item.enumName) {
            case 'BusinessOldMachineStatusEnum':
              this.BusinessOldMachineStatusEnum.push(item);
              break;
            case 'BusinessRecycleStatusEnum':
              this.BusinessRecycleStatusEnum.push(item);
              break;
            case 'BusinessSettleStatusEnum':
              this.BusinessSettleStatusEnum.push(item);
              console.log('BusinessSettleStatusEnum',this.BusinessSettleStatusEnum);
              break;
            case 'OldMachineSubsidyOnlineStatusEnum':
              this.OldMachineSubsidyOnlineStatusEnum.push(item);
              console.log('OldMachineSubsidyOnlineStatusEnum111111111111111111111111111111111111111',this.OldMachineSubsidyOnlineStatusEnum);
              break;
            case 'JdExceptionTypeEnum':
              this.JdExceptionTypeEnum.push(item);
              console.log('JdExceptionTypeEnumJdExceptionTypeEnumJdExceptionTypeEnum',this.JdExceptionTypeEnum)
              break;
            case 'InvoiceSignStatusEnum':
              this.InvoiceSignStatusEnum.push(item);
              console.log('InvoiceSignStatusEnumInvoiceSignStatusEnumInvoiceSignStatusEnum',this.InvoiceSignStatusEnum)
              break;
            case 'OldMachineRecoveryStatus':
              this.OldMachineRecoveryStatus.push(item);
              console.log('OldMachineRecoveryStatusOldMachineRecoveryStatusOldMachineRecoveryStatus',this.OldMachineRecoveryStatus)
              break;
            case 'PayTypeEnum':
              this.PayTypeEnum.push(item);
              console.log('2222222222222222',this.PayTypeEnum);
              break;
          }
        });
      }
    },
    //获取商用旧机数据 重新组装 旧机类型以及下面的旧机系列
    async getCOM(){
      let res = await getCOMType()
      if (res.statusCode === 200) {

        this.COMType = this.restructureCOMType(res.data);
        console.log('COMType',this.COMType);
      }
    },
    restructureCOMType(data) {
      const groupedData = data.reduce((acc, item) => {
        const key = item.category;
        if (!acc[key]) {
          acc[key] = [];
        }
        acc[key].push(item);
        return acc;
      }, {});
      return groupedData;
    }
  }
};



// WEBPACK FOOTER //
// ./src/views/COldForNewService/enumMixin.js